export const SET_WIZARD_SAVED_MAPPING = 'SET_WIZARD_SAVED_MAPPING';
export const SET_WIZARD_SAVED_CONFIGURATION = 'SET_WIZARD_SAVED_CONFIGURATION';
export const SET_WIZARD_SAVED_BUNDLES = 'SET_WIZARD_SAVED_BUNDLES';
export const SET_WIZARD_TRIGGER = 'SET_WIZARD_TRIGGER';
export const SET_WIZARD_LOADED = 'SET_WIZARD_LOADED';
export const SET_WIZARD_DATA_LOADED = 'SET_WIZARD_DATA_LOADED';
export const START_WIZARD_ENV_CHECK = 'START_WIZARD_ENV_CHECK';
export const FINISH_WIZARD_ENV_CHECK = 'FINISH_WIZARD_ENV_CHECK';
export const START_WIZARD_GET_SCENARIO = 'START_WIZARD_GET_SCENARIO';
export const FINISH_WIZARD_GET_SCENARIO = 'FINISH_WIZARD_GET_SCENARIO';
export const SET_WIZARD_OAUTH_URL = 'SET_WIZARD_OAUTH_URL';
export const GETTING_WIZARD_OAUTH_URL = 'GETTING_WIZARD_OAUTH_URL';
export const SET_WIZARD_SAVED_CREDENTIALS = 'SET_WIZARD_SAVED_CREDENTIALS';
export const SET_WIZARD_ENVIRONMENTS = 'SET_WIZARD_ENVIRONMENTS';
export const SET_WIZARD_ONGOING_EXECUTION_LOGS = 'SET_WIZARD_ONGOING_EXECUTION_LOGS';
export const SET_WIZARD_ONGOING_EXECUTION_LOG_COUNT = 'SET_WIZARD_ONGOING_EXECUTION_LOG_COUNT';

export const CLEAR_WIZARD = 'CLEAR_WIZARD'

export const SET_FAVICON = 'SET_FAVICON'




// WEBPACK FOOTER //
// ./src/lib/wizard/actions/types.js